<template>
  <transition :name="showBack ? 'z-slide-right' : ''">
    <div v-show="feedBackShow" class="pop_feedback_wrapper">
      <div class="feedback_top">
        <div class="back_icon">
          <img
            v-show="showBack"
            src="https://pic2.zhuanstatic.com/zhuanzh/591a31fc-4366-4cee-86d3-624f69dccaf1.png"
            @click="closeFeedback"
          />
        </div>

        <span class="top_title">意见反馈</span>
        <div class="mask_img" @click="closeFeedback">
          <img
            src="https://pic6.zhuanstatic.com/zhuanzh/1b8afb9f-426f-46dc-92b2-4cc6dcfdcce3.png"
          />
        </div>
      </div>
      <div class="feedback_content">
        <div class="content_title">
          {{ inputFocus ? '请描述具体问题或改进建议：' : mainTitle }}
        </div>
        <z-checker
          v-show="!inputFocus"
          v-model="optionId"
          :options="checkerOptions"
          type="checkbox"
          valueKey="optionId"
          textKey="optionDetail"
          @change="checkerChange"
        />
        <section class="ask-wrap">
          <div class="content_input">
            <z-field
              id="testInput"
              ref="inputField"
              v-model="feedbackDetail"
              class="feecback_input"
              type="textarea"
              :class="['question-simple-input', feedbackDetail.length > 0 && 'hide-img']"
              :autosize="{ maxHeight: 115, minHeight: 115 }"
              placeholder="     填写的信息越全，问题越有可能解决哦~"
              :maxlength="500"
              count-word
              @focus="inputBlur"
              @blur="onBlur"
              @input="inputChange"
            />
          </div>
          <div class="upload">
            <z-upload
              v-model="imageFiles"
              accept="image/*, video/*"
              :isBtnFlex="true"
              :max="9"
              :isAppUploadLoading="true"
              :zzapp="inZZ"
              :action="action"
              :process-file="processFile"
              @file-removed="onFileChange"
              @file-success="onFileChange"
            >
              <div class="custom-upload">
                <z-upload-btn v-show="imageFiles.length <= 8">
                  <img
                    src="https://pic1.zhuanstatic.com/zhuanzh/b79337f2-5564-4a8a-aaa4-33f77ff4ce7c.png"
                    alt=""
                  />
                </z-upload-btn>
                <z-upload-file
                  v-for="(file, index) in showImageList"
                  :key="index"
                  :file="file"
                  @click="clickPic(showImageList, file, index)"
                />
              </div>
            </z-upload>
          </div>
        </section>
        <div v-show="!inputFocus" class="upload-tips-wrap">
          <img
            src="https://pic3.zhuanstatic.com/zhuanzh/5f042ecf-e2ba-45e2-9371-b999558f05a0.png"
          />上传“有效截图”可以让<span>问题优先被发现</span>哦！
        </div>
      </div>
      <z-button-group v-show="!inputFocus">
        <z-button
          id="selfRegion"
          v8
          :disabled="!feedbackDetail && !showImageList.length"
          type="primary"
          size="large"
          @click.stop="submitFeedback()"
          >提交</z-button
        >
      </z-button-group>
    </div>
  </transition>
</template>
<script>
  import Vue from 'vue'
  import {
    Checker,
    Field,
    Button,
    CellGroup,
    Toast,
    Upload,
    ImagePreview,
    ButtonGroup,
  } from '@zz-common/zz-ui'
  import compress from '@zz-common/zz-ui/lib/utils/image'
  import { isIphonex } from '../../utils/index'
  import native from '@zz-common/native-adapter'
  import { setPicSize } from '@zz-common/zz-utils'
  import { getQcItemFeedbackInfo, submitQcItemFeedback } from '../../apis/index'
  Vue.use(Checker).use(Field).use(Button).use(CellGroup).use(Upload).use(ButtonGroup)
  export default {
    name: 'quality-feedback',
    components: {
      // [Checker.name]: Checker,
      // [Field.name]: Field,
      // [CellGroup.name]: CellGroup,
      // [Button.name]: Button,
      // [Upload.name]: Upload,
    },
    props: {
      showBack: {
        type: Boolean,
        default: true,
      },
      qcCode: {
        type: String,
        default: () => '',
      },
      firstItemId: {
        type: String,
        default: () => '',
      },
      secondItemId: {
        type: String,
        default: () => '',
      },
      thirdItemId: {
        type: String,
        default: () => '',
      },
      // 渠道id
      channelId: {
        type: Number,
        default: () => 1,
      },
      // 标题
      popTitle: {
        type: String,
        default: '',
      },
      mainTitle: {
        type: String,
        default: '很抱歉没有帮助到你，请问哪些地方让你产生疑虑？',
      },
      jggId: {
        type: String,
        default: '',
      },
      cateId: {
        type: [Number, String],
        default: '',
      },
    },
    data() {
      return {
        checkerOptions: [], // 反馈数据
        inputField: null,
        optionId: [], //反馈选项id
        cacheOptionId: [], //缓存改变之前的optionid
        feedbackDetail: '', // 反馈内容
        feedBackShow: false,
        imageFiles: [],
        showImageList: [],
        inZZ: false,
        action: {
          data: {
            sign: window.btoa(encodeURIComponent(Date.now())).split('').reverse().join(''),
          },
        },
        inputFocus: false,
      }
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
    },
    mounted() {
      this.inZZ = native.in('zz')
      this.watchKeybord()
    },
    methods: {
      setIsIphonex() {
        return isIphonex()
      },
      watchKeybord() {
        const me = this
        let oriWinHeight = window.innerHeight
        window.onresize = function () {
          const newHeight = window.innerHeight
          // 阀值大于60判断为键盘收起
          if (newHeight - oriWinHeight > 60) {
            me.inputFocus = false
          }
          oriWinHeight = newHeight
        }
      },

      closeFeedback() {
        this.$emit('close')
        this.feedBackShow = false
        this.optionId = []
        this.feedbackDetail = ''
        this.imageFiles = []
        this.showImageList = []
      },

      // $ 反馈项数据
      feedbackOptions() {
        const params = {
          qcCode: this.qcCode,
          firstItemId: this.firstItemId,
          secondItemId: this.secondItemId,
          thirdItemId: this.thirdItemId,
          channelId: this.channelId,
          cateId: this.cateId,
        }
        getQcItemFeedbackInfo({ request: JSON.stringify(params) })
          .then(({ data }) => {
            this.checkerOptions = data.optionList
          })
          .catch((err) => {
            Toast({
              duration: 800,
              message: err.errorMsg,
            })
          })
      },

      // $ 监听反馈项数据值
      checkerChange(value) {
        this.optionId = value
        //是否新增选择
        const addStatus = this.optionId.length > this.cacheOptionId.length
        if (value.length && addStatus) {
          const oldText = this.feedbackDetail
          const addText = this.checkerOptions.filter((o) => {
            return o.optionId === value[value.length - 1]
          })[0].optionDetail
          if (oldText.indexOf(addText) == '-1') {
            const mergeText = `${oldText}${oldText ? '\n' : ''}${addText}:`
            if (mergeText.length <= 500) {
              this.feedbackDetail = mergeText
            } else {
              Toast('最多输入500个字哦')
            }
          }
        }
        this.cacheOptionId = JSON.parse(JSON.stringify(value))
      },

      // $ 获取焦点
      inputBlur() {
        this.inputFocus = true
      },

      // $ 失去焦点
      onBlur() {
        this.inputFocus = false
      },
      // $ 提交质检项反馈
      submitFeedback() {
        const feedbackPhoto = this.imageFiles.length
          ? this.imageFiles
              .map((o) => {
                return o.url
              })
              .join('|')
          : ''
        const params = {
          qcCode: this.qcCode,
          firstItemId: this.firstItemId,
          secondItemId: this.secondItemId,
          thirdItemId: this.thirdItemId,
          channelId: this.channelId,
          optionId: this.optionId.join(','),
          feedbackDetail: this.feedbackDetail,
          feedbackPhoto,
          title: this.popTitle,
          jggId: this.jggId,
          cateId: this.cateId,
        }

        submitQcItemFeedback({ request: JSON.stringify(params) })
          .then((data) => {
            this.optionId = []
            this.feedbackDetail = ''
            this.imageFiles = []
            this.showImageList = []
            Toast.success({
              duration: 800,
              message: '感谢您的反馈',
            })
            const backup = {
              sortId: 1,
              sortName: '无帮助',
              qcCode: this.qcCode,
              firstItemId: this.firstItemId,
              secondItemId: this.secondItemId,
              thirdItemId: this.thirdItemId,
            }
            setTimeout(() => {
              this.feedBackShow = false
              this.$emit('complete', backup)
            }, 500)
          })
          .catch((err) => {
            Toast({
              duration: 800,
              message: err.errorMsg,
            })
          })
      },
      processFile(file, next) {
        // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
        compress(
          file,
          {
            compress: true,
          },
          next
        )
      },
      onFileChange() {
        const imgsList = []
        const videoList = []
        this.imageFiles.forEach((it) => {
          if (it.type.indexOf('image') > -1) {
            imgsList.unshift(it)
          }
          if (it.type.indexOf('video') > -1) {
            videoList.unshift(it)
          }
        })
        const mixList = [...videoList, ...imgsList]
        this.showImageList = mixList
      },
      clickPic(files, file, index) {
        if (!file) return null
        const mediaList = []
        const images = []
        const videoVos = []
        Array.isArray(files) &&
          files.forEach((item) => {
            if (item.type.indexOf('image') > -1) {
              mediaList.push(item.url)
              images.push(item.url)
            }
            if (item.type.indexOf('video') > -1) {
              mediaList.push({
                picUrl: item.response,
                auto: false,
                muteBtn: false,
                controls: true,
                videoUrl: item.url,
              })
              videoVos.push({
                picUrl: item.response,
                auto: false,
                muteBtn: false,
                controls: true,
                videoUrl: item.url,
              })
            }
          })
        ImagePreview({
          images,
          videoVos,
          mediaList,
          adaptApp: true,
          showLoading: true,
          startPosition: index,
          withMedia: true,
          withVideo: true,
          showIndex: true,
          showIndicators: true,
        })
      },
      inputChange(val) {
        if (val.length == 500) {
          Toast('最多输入500个字哦')
        }
      },
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/animation.scss';

  .pop_feedback_wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: #fff;
    padding-top: 24px;
    box-sizing: border-box;
    .feedback_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      padding: 0 32px;
      .back_icon {
        width: 40px;
        height: 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .top_title {
        height: 32px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #111111;
        line-height: 32px;
      }
      .mask_img {
        width: 24px;
        height: 24px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .feedback_content {
      position: relative;
      padding: 0 32px;
      max-height: calc(100% - 228px);
      overflow-y: scroll;
      box-sizing: border-box;
      .content_title {
        margin-top: 16px;
        margin-bottom: 24px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #111111;
        line-height: 48px;
      }
      .ask-wrap {
        background: #f8f8f8;
        border-radius: 16px;
        overflow: hidden;
      }
      .content_input {
        position: relative;
        .question-simple-input {
          padding: 19px 24px 26px;
          background: #f8f8f8
            url('https://pic4.zhuanstatic.com/zhuanzh/42f49b1b-e632-4b55-9191-2365ddf4ec00.png')
            no-repeat 24px 30px;
          background-size: 27px 27px;

          &.hide-img {
            background-image: none;
          }
        }
      }
      .upload {
        margin-bottom: -20px;

        .custom-upload {
          padding: 0 0 40px 20px;
          overflow-x: scroll;
          display: block;
          white-space: nowrap;

          .z-upload-btn {
            position: relative;
            display: inline-block;
            vertical-align: bottom;
            overflow: hidden;
            border-radius: 16px;
            width: 144px;
            height: 144px;
            margin: 0 12px 0 0;
            background: #ffffff;

            img {
              width: 100px;
              height: 70px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }

            &:active {
              background: #f2f3f5;
            }

            i {
              color: #999;
              font-size: 40px;
              font-style: normal;
            }
          }

          .z-upload-file {
            position: relative;
            display: inline-block;
            vertical-align: bottom;
            margin: 0 12px 0 0;
            border-radius: 16px;
            overflow: hidden;
            width: 144px;
            height: 144px;
          }
        }

        .z-upload-file-def {
          width: 144px;
          height: 144px;
        }
      }
      .upload-tips-wrap {
        height: 26px;
        font-size: 26px;
        color: #a0a0a0;
        margin: 36px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-right: 4px;
          width: 26px;
          height: 26px;
          object-fit: cover;
        }

        span {
          color: #f69a42;
          font-weight: 500;
        }
      }

      .z-checker-item {
        margin-left: 0;
        padding: 0 28px;
        height: 56px;
        border-radius: 8px;
        margin-bottom: 24px;
        margin-right: 24px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .z-checker-item_active {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #ff483c;
        background: #ffefef;
      }
      .z-checker-item_active::after {
        border: 0;
      }
    }
  }
  .z-cell {
    .z-field__control {
      user-select: auto;
      font-size: 26px;
    }
    textarea::placeholder {
      color: #c6c6c6;
    }
  }
  .z-field__body {
    line-height: 2;
  }
</style>
